module.exports = __webpack_public_path__ + "static/media/IMG_0557.663f4765.JPG";